<template>
  <div>
    <d-row
      v-if="!change_of_view"
      class="d-flex ml-0 mb-3 page-filters w-100">
      <validation-observer
        ref="orders-list-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">

        <d-input
          placeholder="Szukana fraza (podstawowe dane klienta, numer zamówienia, podstawowe dane placówki)"

          v-model="filters.search" />
        <validation-provider
          :rules="filters.delivery_date_to ? 'required' : ''"
          name="delivery_date_from"
          v-slot="{ errors }">
          <date-picker
            valueType="format"
            type="date"
            class="ml-2"
            style="width: 200px;"
            :class="{'invalid-date': errors.length }"
            v-model="filters.delivery_date_from"
            :state="errors.length ? 'invalid' : null"
            :placeholder="'Data od'"/>
        </validation-provider>
        <validation-provider
          :rules="filters.delivery_date_from ? 'required' : ''"
          name="delivery_date_to"
          v-slot="{ errors }">
          <date-picker
            valueType="format"
            class="ml-2"
            type="date"
            :class="{'invalid-date': errors.length }"
            style="width: 200px;"
            v-model="filters.delivery_date_to"
            :placeholder="'Data do'"/>
        </validation-provider>
        <v-select
          class="ml-2 w-100"
          :options="suppliers"
          :reduce="supplier => supplier.id"
          v-model="filters.supplier_id"
          :loading="!suppliers_loaded && !suppliers_load_error"
          placeholder="Wybierz dostawcę"
          :disabled="!suppliers_loaded && !suppliers_load_error"
          :searchable="false"
          label="name">
          <template
            slot="option"
            slot-scope="option">
            <div class="d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
          <template
            slot="selected-option"
            slot-scope="option">
            <div class="selected d-center">
              {{ option.name ? option.name : (option.id ? 'Dostawca #' + option.id : '') }}
            </div>
          </template>
          <template slot="no-options">
            <div
              v-if="suppliers_load_error"
              class="text-center py-2">
              <div class="text-danger mb-1">Błąd ładowania dostawców</div>
              <a
                href="#"
                @click.prevent="loadSuppliers">Ponów</a>
            </div>
            <div v-else>
              Brak wyników
            </div>
          </template>
        </v-select>
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          :disabled="!loaded"
          @click.prevent="validateFiltersForm">Szukaj</d-button>
        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          :disabled="!loaded"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>
    <div
      class="orders-summary bg-light border rounded px-3 py-2 mb-3 small"
      :style="{ opacity: loaded && !load_error && summary ? 1 : 0.5 }">
      <div
        class="d-flex flex-wrap align-items-center"
        style="gap: 8px 24px;">
        <span class="font-weight-bold">
          Podsumowanie
          <template v-if="loaded && !load_error && summary">
            ({{ summary.orders_count }} {{ pluralizeOrders(summary.orders_count) }})
          </template>
        </span>
        <span class="text-nowrap">
          Wpłacono: <strong>{{ loaded && !load_error && summary ? summary.paid.toFixed(2) + ' zł' : '-' }}</strong>
        </span>
        <span class="text-nowrap">
          Kwota: <strong>{{ loaded && !load_error && summary ? summary.price.toFixed(2) + ' zł' : '-' }}</strong>
        </span>
        <span class="text-nowrap">
          Do zapłaty: <strong :class="{ 'text-danger': loaded && !load_error && summary }">{{ loaded && !load_error && summary ? summary.to_pay.toFixed(2) + ' zł' : '-' }}</strong>
        </span>
      </div>
    </div>

    <d-card style="width: 100%;">
      <table
        v-if="!change_of_view"
        class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th
              scope="col"
              class="border-0">Data dostawy</th>
            <th
              scope="col"
              class="border-0">Adres dostawy</th>
            <th
              scope="col"
              class="border-0">Kwota</th>
            <th
              scope="col"
              class="border-0">Kierowca</th>
            <th
              scope="col"
              class="border-0">Produkty</th>
            <th
              scope="col"
              class="border-0 text-center">Pudełka</th>
            <th
              scope="col"
              class="border-0 text-center"
              width="210">Akcje</th>
          </tr>
        </thead>
        <tbody v-if="loaded && !load_error && orders">
          <tr
            v-for="(order, index) of orders.data"
            :key="'user-' + index">
            <td class="align-middle">
              {{ order.delivery_date }}
            </td>
            <td class="align-middle">
              <span class="bottom-text">
                <span
                  class="bottom-text-value"
                  v-if="order.shop_address && order.shop_post_code && order.shop_city">
                  <span class="text-secondary">Adres: </span>
                  <span class="text-success">{{order.shop_post_code + ' ' + order.shop_city}}</span><br>
                  <span class="text-secondary">Ulica: </span>
                  <span class="text-success">{{ order.shop_address }}</span>
                </span>
              </span>
            </td>
            <td class="align-middle">
              <span :class="getOrderPriceClass(order)">
                {{(order.payment_transferred + order.payment_cash + order.payment_card).toFixed(2)}} / {{ order.price.toFixed(2) }} zł
              </span>
            </td>
            <td class="align-middle">
              <i
                class="material-icons"
                style="font-size: 1.2rem">{{ order.supplier_name ? 'person_search' : 'person' }}</i>
              {{ order.supplier_name ? order.supplier_name : 'Brak dostawcy' }}
            </td>
            <td
              class="align-middle"
              v-if="order.order_products">
              {{ order.order_products.length }}
            </td>
            <td class="align-middle text-center">
              <span
                v-if="order"
                class="text-primary">
                {{ order.containers_number }}
              </span>
            </td>
            <td
              class="align-middle">
              <div
                class="d-flex flex-wrap justify-content-end"
                style="gap: 8px;">
                <d-button
                  theme="info"
                  @click.prevent="showOrderModal(order)"
                  class="action-button"
                  title="Podgląd">
                  <i class="material-icons">search</i>
                </d-button>
                <d-button
                  theme="primary"
                  @click.native="$router.push('/zamowienia/edycja/' + order.id)"
                  class="action-button"
                  title="Edytuj">
                  <i class="material-icons">edit</i>
                </d-button>
                <d-button
                  theme="warning"
                  :class="{
                    'action-button': true,
                    'isLoading': paymentInProgress === order.id
                  }"
                  @click="submitExpressPayment(order)"
                  :disabled="!!paymentInProgress || !getIsExpressPaymentEnabled(order)"
                  tile="Opłać">
                  <i class="material-icons">bolt</i>
                  <i
                    class="material-icons"
                    style="transform: rotate(360deg);">euro_symbol</i>
                </d-button>
              </div>
            </td>
          </tr>
          <tr v-if="orders.length === 0 || orders.data.length === 0">
            <td
              colspan="7"
              class="text-center">
              Brak zamówień do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <d-alert
        v-if="load_error"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a
          href="javascript:window.location.reload();"
        class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>

      <div
        v-else-if="!loaded"
        class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>
    </d-card>

    <pagination
      v-if="loaded && !load_error"
      :meta-data="paginationMetaData"
      :initial-page="currentPage"/>

    <order-modal
      v-if="order.id"
      :key="show_order_modal_key"
      :close-modal="closeOrderModal"
      :order-id="order.id"
      :show-modal="show_order_modal"
      :customer-id="customer_id" />

    <orders-bulk-payment-info
      :close-modal="closeExpressPaymentInfo"
      :show-modal="express_payment_modal"
      :different-payments="different_payments" />
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from '../../utils/FormUtils.js';
import HasFilters from '@/mixins/HasFilters';
import HasPagination from '@/mixins/HasPagination';
import ListUtils from '../../utils/ListUtils.js';
import CalendarUtils from '@/utils/CalendarUtils';
import PaymentUtils from '@/utils/PaymentUtils';
import Pagination from '../../components/common/Pagination.vue';
import OrderFormCalendar from '@/components/forms/orders/OrderFormCalendar';
import OrderSupplier from '@/views/Orders/OrdersSupplier';
import OrdersCollapse from '@/views/Orders/OrdersCollapse';
import OrderFile from '@/views/Orders/OrdersFile';
import OrderModal from '../../components/forms/orders/OrderModal';
import DatePicker from 'vue2-datepicker';
import OrdersBulkPaymentInfo from './OrdersBulkPaymentInfo.vue';

const moment = require('moment');

export default {
  name: 'orders-history',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    OrderModal,
    OrderFile,
    OrdersCollapse,
    OrderSupplier,
    OrderFormCalendar,
    CalendarUtils,
    DatePicker,
    'pagination': Pagination,
    OrdersBulkPaymentInfo
  },
  data () {
    return {
      orders: [],
      summary: null,
      conditions: [],
      order: [],
      suppliers: [],
      suppliers_loaded: false,
      suppliers_load_error: false,
      supplies: [],
      ids_all: false,
      loaded: false,
      load_error: false,
      remove_in_progress: false,
      show_calendar: false,
      show_modal_file: false,
      export_file: false,
      paymentInProgress: 0,
      supplier_modal: false,
      button_disabled_pdf: false,
      show_weighing_module: false,
      change_of_view: false,
      payment_module_data: [],
      payment_module_id: 0,
      transportKey: 0,
      show_weighing_module_data: [],
      show_payment_module: false,
      supplies_check: false,
      show_order_modal_key: 0,
      show_order_modal: false,
      order_modal_data: {},
      week_days: ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'Nd'],
      week_day_names: ['Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota', 'Niedziela'],
      month: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień', '', ''],
      month_short: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru', '', ''],
      month_number: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '', ''],
      day_number: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '', ''],
      first_day_prev: '',
      day_prev: '',
      customer_id: '',
      day: '',
      current_date_copy_date: '',
      downloading: '',
      days_count: 1,
      supplier_id: '',
      id_supplier: '',
      customer_settlement_method: '',
      supplier_key: 0,
      count: 0,
      modal_file_key: 0,
      date_key: 0,
      date_context: moment(),
      current_date: {
        date: 0,
        month: 0,
        year: 0,
        yearAdd: 0
      },
      filters: {
        search: '',
        user_id: '',
        customer_id: '',
        shop_id: '',
        supplier_id: '',
        delivery_date_from: '',
        delivery_date_to: '',
      },
      express_payment_modal: false,
      different_payments: [],
    };
  },
  watch: {
    ids_all (val) {
      if (val) {
        this.ids = this.orders.data.map((el) => el.id);
      } else {
        this.ids = [];
      }
    }
  },
  mounted () {
    this.loadSuppliers();
    this.filters.customer_id = this.$route.params.id;
    this.customer_id = this.$route.params.id;
    this.debouncedLoadFilteredData();
  },
  methods: {
    showOrderModal (order) {
      this.order = order;
      this.show_order_modal = true;
      this.order_modal_data = order;
    },
    closeOrderModal () {
      this.show_order_modal = false;
    },
    openModalFile () {
      this.show_modal_file = true;
    },
    closeModalFile () {
      this.show_modal_file = false;
      this.modal_file_key += 1;
    },
    refreshPayment () {
      this.loadFilteredData();
    },
    refreshItems () {
      this.loadFilteredData();
    },
    loadFilteredData () {
      this.loaded = false;
      this.load_error = false;
      this.supplies_check = false;
      this.ids = [];
      let where = {
        search: this.filters.search,
        supplier_id: this.filters.supplier_id ? this.filters.supplier_id : '',
        shop_id: this.filters.shop_id ? this.filters.shop_id : '',
        customer_id: this.$route.params.id,
        user_id: this.filters.user_id ? this.filters.user_id : '',
        delivery_date_from: this.filters.delivery_date_from ? this.filters.delivery_date_from : '',
        delivery_date_to: this.filters.delivery_date_to ? this.filters.delivery_date_to : '',
      };
      where.delivery_date = this.startDate;
      this.$http.post(
        '/orders/items?page=' + this.currentPage,
        {
          pagination: true,
          with_summary: 1,
          where
        }
      ).then(response => {
        this.paginationMetaData = response.data.meta || null;
        this.orders = response.data;
        this.summary = response.data.summary || null;
        this.conditions = response.data.conditions;
        this.supplies = response.data.supplies;
        let arr = [];
        let arrNone = [];
        for (let i = 0; i < response.data.data.length; i++) {
          if (response.data.data[i].supplier_id !== 0) {
            arr.push(response.data.data[i].supplier_id);
          }
          if (response.data.data[i].supplier_id === 0) {
            arrNone.push(response.data.data[i].supplier_id);
          }
        }
        this.count = arr.length;
        this.countNone = arrNone.length;
        if (response.data.supplies[0].orders_count !== 0) {
          this.supplies_check = true;
        }
        if (response.data) {
          if (response.data.data.length) {
            this.button_disabled_pdf = false;
          } else {
            this.button_disabled_pdf = true;
          }
        }
        this.loaded = true;
      }).catch(error => {
        console.error(error);
        this.load_error = true;
        this.loaded = true;
      });
    },
    closeSupplierModal () {
      this.supplier_modal = false;
      this.supplier_key += 1;
    },
    getSingleOrder (id) {
      this.downloading = id;
      FormUtils.loadAdditionalData(this, {
        endpoint: '/orders/item/' + id,
        outputKey: 'order',
        params: {
          pagination: false
        },
        successAction: () => {
          setTimeout(() => {
            this.downloading = '';
            this.supplier_id = this.order.supplier_id;
            setTimeout(() => {
              if (this.supplier_id !== '') {
                this.supplier_modal = true;
              }
            }, 100);
          }, 200);
        }
      });
    },
    loadSuppliers () {
      this.suppliers_loaded = false;
      this.suppliers_load_error = false;
      ListUtils.loadItemsData(this, {
        endpoint: '/suppliers/items',
        listField: 'suppliers',
        loadedKey: 'suppliers_loaded',
        errorKey: 'suppliers_load_error',
        pagination: false,
        params: {
          where: { active: 1 }
        }
      });
    },
    clearFilters () {
      this.filters = {
        search: '',
        supplier_id: '',
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    changeOfView () {
      this.change_of_view = !this.change_of_view;
      if (this.change_of_view === false) {
        this.transportKey += 1;
      }
    },
    validateFiltersForm () {
      FormUtils.validate(this.$refs['orders-list-filters-form'], () => {
        this.$bus.$emit('pagination-reset');
        this.debouncedLoadFilteredData();
      });
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    getOrderPriceClass (order) {
      let classList = 'text-nowrap';
      if (order.payment_cash === 0 && order.payment_transferred === 0 && order.payment_card === 0) {
        return classList + ' order-payments-red';
      }

      if (order.payment_cash !== 0) {
        if (order.payment_cash !== order.price) {
          return classList + ' order-payments-blue';
        }

        return classList + ' order-payments-green';
      }

      if (order.payment_transferred !== 0) {
        if (order.payment_transferred !== order.price) {
          return classList + ' order-payments-blue';
        }

        return classList + ' order-payments-green';
      }

      if (order.payment_card !== 0) {
        if (order.payment_card !== order.price) {
          return classList + ' order-payments-blue';
        }

        return classList + ' order-payments-green';
      }

      return classList + ' order-payments-red';
    },
    submitExpressPayment (order) {
      this.paymentInProgress = order.id;
      PaymentUtils.submitExpressPayment(this, {
        orders: JSON.parse(JSON.stringify([order])),
        selectedOrdersIDs: order.id,
        isSinglePayment: true,
        successAction: this.expressPaymentSuccessAction,
        failAction: () => {
          this.paymentInProgress = 0;
        },
        cancelAction: () => {
          this.paymentInProgress = 0;
        }
      });
    },
    expressPaymentSuccessAction (response) {
      if (response.different && response.different.length) {
        this.openExpressPaymentInfo(response.different);
      }
      this.paymentInProgress = 0;
      this.refreshItems();
    },
    openExpressPaymentInfo (differentPayments) {
      this.different_payments = differentPayments;
      this.express_payment_modal = true;
    },
    closeExpressPaymentInfo () {
      this.express_payment_modal = false;
      this.different_payments = [];
    },
    pluralizeOrders (count) {
      if (count === 1) {
        return 'zamówienie';
      }
      let lastTwo = count % 100;
      let lastOne = count % 10;
      if (lastOne >= 2 && lastOne <= 4 && (lastTwo < 10 || lastTwo >= 20)) {
        return 'zamówienia';
      }
      return 'zamówień';
    },
    getIsExpressPaymentEnabled (order) {
      if (!order) {
        return false;
      }

      return order.is_completed_weighting && order.available_settlement_methods.length && Number(order.price) !== (Number(order.payment_cash) + Number(order.payment_transferred) + Number(order.payment_card));
    }
  }
};
</script>
<style lang="scss">
  @import '../../assets/scss/order-list';
  @import '../../assets/scss/order-popup';

  .action-button {
    display: flex;
    .material-icons {
      left: 0;
      margin: auto;
      top: 0;
    }
  }
</style>

